<template>
  <v-app>
    <nav v-if="authStore.isAuthenticated">
      <v-app-bar app height="20" class="rounded-be-xl shadow" color="#FF4081">
        <!-- <v-toolbar-title
          text="Nurse Dashboard"
          class="text-h5"
        ></v-toolbar-title> -->
        <template v-slot:extension>
          <v-tabs>
            <v-tab v-if="!authStore.isAuthenticated" router to="/" text="Login"></v-tab>
            <!-- <v-tab
              v-if="authStore.isAuthenticated"
              router
              to="/dashboard"
              text="Dashboard"
            ></v-tab> -->
            <v-tab v-if="authStore.isAuthenticated" router to="/user_detail" text="Home"></v-tab>
            <v-tab
              v-if="authStore.isAuthenticated && (authStore.userRole === 'admin' || authStore.userRole === 'subadmin')"
              router to="/adminDashboard" text="ค้นข้อมูลนักศึกษา" class="font-weight-bold"></v-tab>
            <v-tab
              v-if="authStore.isAuthenticated && (authStore.userRole === 'admin' || authStore.userRole === 'subadmin')"
              router to="/addStudent" text="เพิ่มนักศึกษา" class="font-weight-bold"></v-tab>
            <v-tab
              v-if="authStore.isAuthenticated && (authStore.userRole === 'admin' || authStore.userRole === 'subadmin')"
              router to="/Report" text="สถิติ PLO" class="font-weight-bold"></v-tab>
            <!-- <v-tab
              v-if="authStore.isAuthenticated && authStore.userRole === 'admin'"
              router
              to="/qrScan"
              text="เพิ่มคะแนนสอบ"
              class="font-weight-bold"
            ></v-tab> -->
            <!-- <v-tab
              v-if="authStore.isAuthenticated && authStore.userRole === 'admin'"
              router
              to="/genPDF"
              text="PDF (Show)"
              class="font-weight-bold"
            ></v-tab> -->
            <v-tab v-if="authStore.isAuthenticated && authStore.userRole === 'admin'" router to="/add_PLO"
              text="เพิ่ม PLO" class="font-weight-bold"></v-tab>
            <!-- <v-tab
              v-if="authStore.isAuthenticated && authStore.userRole !== 'admin'"
              :disabled="true"
              router
              to="/Academic_Result"
              text="Academic Result"
            ></v-tab> -->
            <v-tab v-if="
              authStore.isAuthenticated && authStore.userRole === 'student'
            " router to="/student_PLO" text="PLO" :v-tooltip:bottom="authStore.user.isDefaultPassword
              ? 'กรุณาเปลี่ยนรหัสผ่าน.'
              : undefined
              " value="one"></v-tab>
            <!-- <v-tab
              v-if="authStore.isAuthenticated"
              router
              to="/nurseActivity"
              text="กิจกรรมที่ทำ"
            ></v-tab>
            <v-tab
              v-if="authStore.isAuthenticated"
              @click="handleLogout()"
              text="logout"
            ></v-tab> -->
            <!-- <v-tab
              v-if="authStore.isAuthenticated"
              router
              to="/selector"
              text="selector"
            ></v-tab>
            <v-tab
              v-if="authStore.isAuthenticated"
              router
              to="/pdfform"
              text="pdfform"
            ></v-tab> -->
            <!-- <v-tab
              v-if="isAuthenticated && user.role === 'admin'"
              router
              to="/admin"
              text="admin"
            ></v-tab> -->
            <v-tab v-if="authStore.isAuthenticated && authStore.userRole === 'admin'" router to="/alumniStatus"
              text="ศิษย์เก่า" class="font-weight-bold"></v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
    </nav>
    <v-navigation-drawer v-if="authStore.isAuthenticated" v-model="authStore.drawer" :rail="authStore.rail" permanent
      app color="" class="shadow rounded-be-xl elevation-24 mt-n2 shadow bg-pink-lighten-1">
      <v-list>
        <!-- <v-list-item
          :prepend-avatar="
            authStore.user ? authStore.user.photoURL : 'no photo'
          "
          :title="authStore.user ? authStore.user?.name : 'Guest'"
        >
          <template v-slot:append>
            <v-btn
              icon="mdi-chevron-left"
              variant="text"
              @click.stop="authStore.rail = !authStore.rail"
            ></v-btn>
          </template>
        </v-list-item> -->
      </v-list>
      <v-divider></v-divider>

      <v-list density="compact" nav>
        <v-list-item v-if="authStore.isAuthenticated && authStore.userRole === 'student'"
          prepend-icon="mdi-account-edit" title="Account Detail" @click="authStore.editAccount = true"></v-list-item>
        <v-list-item v-if="authStore.isAuthenticated && authStore.userRole === 'student'" prepend-icon="mdi-qrcode-scan"
          title="My Qrcode" @click="generateQrCode()"></v-list-item>
        <v-list-item v-if="
          authStore.isAuthenticated &&
          authStore.userRole === 'student' &&
          isPassed()
        " prepend-icon="mdi-certificate" title="My Certificate" @click="handleCert()"></v-list-item>

        <v-list-item prepend-icon="mdi-logout" title="logout" @click="handleLogout()"></v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="div-box background-gradient" :class="{ 'my-authenticated-class': authStore.isAuthenticated }"
      :style="authStore.isAuthenticated ? { 'margin-left': '3em' } : {}">
      <v-main elevation="20" class="main-box">
        <v-alert closable variant="tonal" v-show="authStore.userRole === 'student' && certData != null && isPassed()" type="success" class="text-h4"
          style="scale: 80%">
          ยินดีด้วย! คุณได้รับการรับรองตามเกณฑ์ PLO แล้ว!!
        </v-alert>
        <v-btn class="pa-2 bg-pink-lighten-1" color="" v-if="
          !isLineBrowser &&
          authStore.isAuthenticated &&
          authStore.userRole === 'student' &&
          isPassed()
        " prepend-icon="mdi-certificate" title="My Certificate" @click="handleCert()">Download ใบ Certificate</v-btn>
        <v-row justify="center" align="center">
          <v-col cols="12" md="6">
            <div class="pa-4 w-100 flex justify-center">
              <v-card v-if="isLineBrowser && !isExternal && authStore.isAuthenticated && authStore.userRole === 'student' && isPassed()" max-width="500"
                class="rounded-xl overflow-hidden border-sm border-success" elevation="2">
                <div class="d-flex">
                  <div class="bg-success px-1"></div>

                  <v-card-text class="pa-6">
                    <div class="d-flex align-center mb-4">
                      <v-icon color="success" size="32" class="mr-3">
                        mdi-alert-circle-outline
                      </v-icon>
                      <h3 class="text-h6 font-weight-bold">
                        เปิดในเบราว์เซอร์ปกติ
                      </h3>
                    </div>

                    <p class="text-body-2 text-grey-darken-2 mb-6">
                      หากคุณต้องการดาวน์โหลดใบประกาศนียบัตร
                      กรุณากดปุ่มด้านล่างเพื่อเปิดหน้าเว็บในเบราว์เซอร์หลัก
                      (Chrome/Safari) เนื่องจาก LINE
                      ไม่รองรับการดาวน์โหลดไฟล์โดยตรง
                    </p>

                    <v-btn block color="success" size="large" rounded="pill" :href="externalLink" class="text-none"
                      elevation="0">
                      ไปที่เบราว์เซอร์หลัก
                      <v-icon end icon="mdi-open-in-new" size="18"></v-icon>
                    </v-btn>
                  </v-card-text>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>

        <router-view v-slot="{ Component, route }">
          <transition name="slide-y-transition" mode="out-in">
            <div :key="route.path">
              <component :is="Component" />
            </div>
          </transition>
        </router-view>

        <!-- <router-view /> -->

        <v-dialog v-if="authStore.user" v-model="authStore.editAccount" width="80%" height="85vh" max-width="1300"
          class="py-2" transition="slide-y-transition" persistent>
          <v-card max-width="1300" prepend-icon="mdi-account-plus" rounded="lg" class="elevation-10 mb-5 p-0"
            title="แก้ไขข้อมูล">
            <v-card-text>
              <v-container class="py-2">
                <v-row justify="start" align="start">
                  <v-col cols="12" md="3">
                    <v-text-field label="รหัสนักศึกษา" variant="outlined" class="" v-model="authStore.user.studentNum"
                      readonly width="100%" hint="ไม่อนุญาติให้แก้ไข" color="red"></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="start" align="center">
                  <v-col cols="12" md="4" sm="12">
                    <v-text-field label="ชื่อ-นามสกุล" disabled variant="outlined" class=""
                      v-model="authStore.user.displayName" readonly width="100%" hint="ไม่อนุญาติให้แก้ไข"
                      color="red"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-text-field label="ชื่อ-นามสกุล ภาษาอังกฤษ" variant="outlined" class="" v-model="enname"
                      :disabled="!authStore.isEditing" hint="เฉพาะ ชื่อ-นามสกุล ไม่ต้องใส่คำนำหน้า" width="100%"
                      color="blue"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-text-field label="email" variant="outlined" disabled class="" v-model="authStore.user.email"
                      readonly width="70%" hint="ไม่อนุญาติให้แก้ไข" color="red"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" md="2" xs="12">
                    <v-btn class="mb-5" variant="elevated" elevation="3" color="blue-darken-3"
                      :text="isChangingPassword ? 'ยกเลิก' : 'เปลี่ยนรหัสผ่าน'" :disabled="!authStore.isEditing"
                      @click="isChangingPassword = !isChangingPassword" width="100%"></v-btn>
                  </v-col>
                  <v-col cols="12" md="3" v-show="isChangingPassword">
                    <v-text-field @click:append-inner="showPassword = !showPassword" :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'
                      " :type="showPassword ? 'text' : 'password'" label="รหัสผ่านใหม่" autocomplete="disabled"
                      variant="outlined" class="mb-auto" v-model="reqPassword" :disabled="!authStore.isEditing"
                      width="100%"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" v-show="isChangingPassword">
                    <v-text-field @click:append-inner="showPasswordCon = !showPasswordCon" :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'
                      " :type="showPasswordCon ? 'text' : 'password'" label="ยืนยันรหัสผ่านใหม่"
                      autocomplete="disabled" variant="outlined" class="mb-auto" v-model="reqPasswordCon"
                      :disabled="!authStore.isEditing" width="100%"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" v-show="isChangingPassword">
                    <v-text-field @click:append-inner="showOldPass = !showOldPass" :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'
                      " :type="showOldPass ? 'text' : 'password'" label="รหัสผ่านเก่า" autocomplete="disabled"
                      variant="outlined" class="mb-auto" v-model="reqOldPassword" :disabled="!authStore.isEditing"
                      width="100%" @blur="showConfirm = true"></v-text-field>
                  </v-col>

                  <v-col cols="12" md="1" v-show="isChangingPassword">
                    <v-btn class="mb-5" variant="elevated" elevation="3" color="green-darken-3" text="ยืนยัน"
                      :disabled="!authStore.isEditing" @click="checkpassword()" width="50%"></v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <template v-slot:actions>
              <v-btn v-if="!authStore.isEditing" class="mb-3 mr-3" variant="elevated" elevation="3"
                color="amber-darken-1" text="แก้ไขข้อมูล" @click="authStore.isEditing = true"></v-btn>

              <v-btn v-if="authStore.isEditing" :disabled="!canChangename" class="mb-3 mr-3" variant="elevated"
                elevation="3" color="green" text="บันทึก" @click="handleEnname()"></v-btn>
              <v-btn class="mb-3 mr-3" variant="elevated" elevation="3" color="red" text="ปิด" @click="
                (authStore.isEditing = false),
                (isChangingPassword = false),
                (authStore.editAccount = false),
                clearinput()
                "></v-btn>
            </template>
          </v-card>
        </v-dialog>

        <v-dialog v-model="authStore.loading" persistent width="300">
          <v-card>
            <v-card-text class="text-center pa-6">
              <v-progress-circular indeterminate color="" size="64"
                class="mb-4 bg-pink-lighten-2"></v-progress-circular>
              <div class="text-h6 mb-2">โปรดรอสักครู่...</div>
              <div class="text-body-2 text--secondary"></div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-if="authStore.isAuthenticated" v-model="qrDialog" persistent max-width="400">
          <v-card>
            <v-card-title class="headline"> QR code ของฉัน </v-card-title>
            <v-card-text class="text-center"> </v-card-text>
            <div v-if="qrCodeData" class="text-center">
              <img :src="qrCodeData" alt="Generated QR code" class="qr-code-img" />
            </div>
            <div v-else>
              <v-card-text> กำลังสร้าง QR code </v-card-text>
            </div>
            <template v-slot:actions>
              <v-btn class="mb-3 mr-3" variant="elevated" elevation="3" color="red" text="ปิด"
                @click="qrDialog = false"></v-btn>
            </template>
          </v-card>
        </v-dialog>
      </v-main>
    </div>
  </v-app>
</template>
<script setup>
import { useAuthStore } from "@/stores/auth";
import { ref, onMounted, computed, watchEffect, onUnmounted, watch } from "vue";
const { proxy } = getCurrentInstance();
import { getCurrentInstance } from "vue";
import router from "@/router";
import axios from "axios";
import { useDisplay } from "vuetify";
const { mobile } = useDisplay();
const authStore = useAuthStore();
// QR-CODE
import QRCode from "qrcode";
import { auth } from "./firebaseConfig";
const qrDialog = ref(false);
const qrCodeData = ref(null);

const generateQrCode = async () => {
  qrCodeData.value = null;
  qrDialog.value = true;
  try {
    const myQrCodeOBJ = {
      id: authStore.user._id || "",
      studentNum: authStore.user.studentNum || "",
      displayName: authStore.user.displayName || "",
    };

    const qrString = JSON.stringify(myQrCodeOBJ);
    const url = await QRCode.toDataURL(qrString, {
      errorCorrectionLevel: "H",
      type: "image/png",
      quality: 0.95,
      margin: 1,
      scale: 4,
    });

    qrCodeData.value = url;
  } catch (err) {
    console.log("fail to crate QRcode", err);
    qrCodeData.value = null;
  }
};

const certData = ref(null);
const checkCertification = async () => {
  const TOKEN = authStore.getBackendJwt();
  const studentNum = authStore.user.studentNum || "";
  if (!TOKEN || !studentNum) {
    // console.log("No token found, user not authenticated.");
    return;
  }

  try {
    const response = await axios.get(
      `/api/CheckCertification`,
      // THIS IS THE START OF THE (single) CONFIG OBJECT
      {
        // 1. Data for a GET request goes into 'params'
        params: {
          studentNum: studentNum,
        },
        // 2. Headers go in the same config object
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 404 ||
            status === 401
          );
        },
      },
      // THIS IS THE END OF THE CONFIG OBJECT
    );

    if (response.status === 200) {
      certData.value = response.data;
      // console.log("Total Passes:", certData.value.data.totalPasses); // Should log 2
      // console.log("Message:", certData.value.data.message);
      return certData.value;
    }
  } catch (err) {
    console.log("got error", err);
  }
};

// QR-CODE
watchEffect(() => {
  if (
    authStore.authInitialized &&
    authStore.userRole === "student" &&
    authStore.backendJwtToken
  ) {
    checkCertification();
  }
});

onMounted(() => {
  if (!authStore.user && authStore.backendJwtToken) {
    authStore.rail = false;
    authStore.drawer = false;
  }
});

// Password related refs
const isChangingPassword = ref(false);
const reqPassword = ref("");
const showPassword = ref(false);
const reqPasswordCon = ref("");
const showPasswordCon = ref(false);
const showConfirm = ref(false);
const isValid = ref(false);
const reqOldPassword = ref("");
const showOldPass = ref(false);
// const usernameRegex = /^\d{17}$/;
const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()\-_+=|\[\]{};:'",.<>/?]{6,}$/;
const checkpassword = () => {
  if (reqPassword.value === reqPasswordCon.value) {
    let newPassword = reqPasswordCon.value;
    const isPasswordValidFormat = validatePassword(newPassword); // check Regex return true or false

    if (isPasswordValidFormat) {
      console.log("condition fullfil");
      isValid.value = true;
      handleChangePassword();
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: `รหัสผ่านใหม่ต้องมีความยาว 6 ตัวอักษรขึ้นไป`,
        icon: "error",
        showConfirmButton: true,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
      return (isValid.value = false);
    }
  } else {
    proxy.$swal({
      title: "เกิดข้อผิดพลาด",
      text: `รหัสผ่านใหม่ทั้งสองไม่ตรงกัน`,
      icon: "error",
      showConfirmButton: true,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
    isValid.value = false;
  }
};
const enname = ref("");
watch(
  () => authStore.user,
  (newUser) => {
    enname.value = newUser?.displayNameEn || "";
  },
  { immediate: true, deep: true },
);
const handleLogout = async () => {
  const result = await proxy.$swal({
    title: "Are you sure?",
    text: "You will be logged out of your account.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, log me out!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      // 1. Reset local state
      certData.value = null;
      enname.value = "";
      qrCodeData.value = null;

      // 2. Clear store state
      await authStore.logout();

      await proxy.$swal({
        title: "Logged Out!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      router.push("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  }
};

const handleCert = async () => {
  let choice = "";
  let language = "";
  let sNum = authStore.user.studentNum;
  const result = await proxy.$swal({
    showCloseButton: true,
    title: "เลือกภาษา",
    text: "กรุณาเลือกภาษาของใบ Certificate",
    iconHtml: '<i class="mdi mdi-file-question-outline"></i>',
    iconColor: "#f5d20a",
    confirmButtonText: "ไทย",
    showDenyButton: true,
    denyButtonText: "English",
    customClass: {
      popup: "swpopup",
      icon: "no-border-icon",
      title: "swtitle",
      htmlContainer: "swtext",
      confirmButton: "confirm-button",
      denyButton: "cancel-button", // You might want to rename this to "deny-button"
    },
  });

  // Block 1: User clicked "ไทย"
  if (result.isConfirmed && authStore.user) {
    language = "th";
    choice = authStore.user.displayName;
    console.log("Rendering Thai Certificate", choice);
    try {
      await authStore.createPdf(choice, language, sNum);
      notify();
      return; // 'return' is fine here
    } catch (err) {
      console.log("Error Rendering Certificate", err);
    }
  }

  // Block 2: User clicked "English"
  // Use 'else if' and REMOVE the semicolon
  else if (result.isDenied && authStore.user) {
    // The 'try' block now goes INSIDE
    try {
      language = "en";
      choice = authStore.user.displayNameEn;
      if (!authStore.user.displayNameEn) {
        return proxy.$swal({
          title: "Error!",
          text: "ไม่พบชื่อ ภาษาอังกฤษในระบบ",
          icon: "error",
        });
      }
      console.log("Rendering English Certificate", choice);
      await authStore.createPdf(choice, language, sNum);
      notify();
      return;
    } catch (err) {
      console.log("error Rendering English Certificate", err);
    }
  }

  // Block 3: User clicked "X" or (if you add one) "Cancel"
  else if (result.isDismissed) {
    console.log("User dismissed the dialog.");
    // Do nothing, the function just ends
  }
};
// function validateUsername(username){
//   return usernameRegex.test(username)
// }

function validatePassword(password) {
  return passwordRegex.test(password);
}
const clearinput = () => {
  reqPassword.value = "";
  reqPasswordCon.value = "";
  reqOldPassword.value = "";
  enname.value = authStore.user?.displayNameEn || "";
};

const handleChangePassword = async () => {
  const authStore = useAuthStore();
  const jwtToken = authStore.getBackendJwt();

  // Check if the token exists before making the request
  if (!jwtToken) {
    console.error("No JWT token found. User not authenticated.");
    await proxy.$swal({
      title: "Authentication Error",
      text: "Please log in to change your password.",
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
    });
    return; // Stop the function if no token is available
  }
  try {
    const response = await axios.post(
      `/api/change-password`,
      {
        newPassword: reqPassword.value,
        confirmPassword: reqPasswordCon.value,
        reqOldpassword: reqOldPassword.value,
      },
      {
        headers: {
          // Add the Authorization header here
          Authorization: `Bearer ${jwtToken}`,
        },
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 404 ||
            status === 401
          );
        },
      },
    );

    if (response.status === 200) {
      await proxy.$swal({
        title: "Successful!",
        text: "เปลี่ยนรหัสผ่านเรียบร้อย!! ",
        icon: "success",
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
      authStore.isEditing = false;
      authStore.editAccount = false;
      reqPassword.value = "";
      reqPasswordCon.value = "";
      reqOldPassword.value = "";
      router.push("/");
      await authStore.logout();
      // authStore.storeBackendJwt(response.data.token);
      // if (response.data.student) {
      //   authStore.user = { ...response.data.student };
      // }

      // console.log("change password debug", authStore.user);
      // console.log("JWTToken:", authStore.getBackendJwt());
    }
    if (response.status === 400) {
      await proxy.$swal({
        title: "Error!",
        text: response.data?.message || "Invalid password or request",
        icon: "error", // Add icon for consistency
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
    if (response.status === 401) {
      await proxy.$swal({
        title: "Error!",
        text: "Invalid password ",
        icon: "error", // Add icon for consistency
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
    if (response.status === 404) {
      await proxy.$swal({
        title: "Error!",
        text: "User not found or endpoint unavailable",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }
  } catch (err) {
    console.log("got error", err);
    await proxy.$swal({
      title: "Network Error!",
      text: "Unable to connect to server. Please try again.",
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
  } finally {
    authStore.loading = false;
    authStore.isEditing = false;
    isChangingPassword.value = false;
  }
};
const canChangename = computed(() => {
  if (enname.value == authStore.user.displayNameEn) {
    return false;
  } else return true;
});
const handleEnname = async () => {
  const authStore = useAuthStore();
  const jwtToken = authStore.getBackendJwt();

  // Check if the token exists before making the request
  if (!jwtToken) {
    console.error("No JWT token found. User not authenticated.");
    await proxy.$swal({
      title: "Authentication Error",
      text: "Please log in to change your name.",
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
    });
    return; // Stop the function if no token is available
  }
  try {
    const response = await axios.post(
      `/api/change-enName`,
      {
        newName: enname.value,
      },
      {
        headers: {
          // Add the Authorization header here
          Authorization: `Bearer ${jwtToken}`,
        },
        validateStatus: (status) => [200, 400, 401, 404].includes(status),
      },
    );

    if (response.status === 200) {
      await proxy.$swal({
        title: "Successful!",
        text: "เปลี่ยนชื่อสำเร็จ!! ",
        icon: "success",
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
      authStore.isEditing = false;
      authStore.editAccount = false;
    } else {
      // Handle 400, 401, 404 using the message sent from your backend
      await proxy.$swal({
        title: "Error!",
        text: response.data?.message || "Something went wrong",
        icon: "error",
        timer: 3000,
      });
    }
  } catch (err) {
    console.error("Change enName error:", err.message);
    await proxy.$swal({
      title: "Network Error!",
      text: "Unable to connect to server. Please try again.",
      icon: "error",
      timer: 3000,
      showConfirmButton: false,
      customClass: {
        container: "my-swal-container", // Apply a custom class to the main SweetAlert container
      },
    });
  } finally {
    authStore.loading = false;
    authStore.isEditing = false;
  }
};

// const isPassed = computed(() => {
//   return certData.value ? certData.value.data.isCertified : false;
// });

const isPassed = () => {
  if (
    authStore.userRole === "student" &&
    certData.value &&
    certData.value.data?.certified === true
  ) {
    return true;
  } else {
    return false; // NOT allow any print yet change it back
  }
};

const notify = async () => {
  const authStore = useAuthStore();
  let studentNum = authStore.user.studentNum;
  console.log(studentNum);
  try {
    const response = await axios.get(
      `/api/notiGenPDF`,
      {
        params: {
          studentNum: studentNum,
        },
      },
      {
        validateStatus: function (status) {
          // All these statuses will be handled within the 'try' block
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 404 ||
            status === 409 ||
            status === 401 ||
            status === 429
          );
        },
      },
    );

    if (response.status === 200) {
      console.log("notify success");
    } else if (response.status === 400) {
      console.log("notify Fail");
    }
  } catch (err) {
    console.log("internal error", err);
  }
};

const isLineBrowser = /Line/i.test(navigator.userAgent);
const isExternal = window.location.search.includes("openExternalBrowser=1");

const externalLink = computed(() => {
  const url = new URL(window.location.href);
  url.searchParams.set("openExternalBrowser", "1");
  return url.toString();
});
</script>
<style>
* {
  box-sizing: border-box;
}

#app {
  font-family: anuphan, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.shadow {
  border: solid rgba(109, 109, 109, 0.329) 2px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
    rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
}

nav {
  text-align: start;
  padding: 0px;
  border: solid rgba(109, 109, 109, 0.329) 2px;
  border-radius: 3px;
}

body {
  margin: 0;
  padding: 0;
}

.div-box {
  overflow: auto;
  margin: 1em;

  /* border: solid rgba(109, 109, 109, 0.329) 2px; */
  padding: 1px;
  height: 96vh;
  border-radius: 10px;

  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
    rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
}

.background-gradient {
  background: #eeaeca;
  background: linear-gradient(56deg,
      rgba(238, 174, 202, 1) 0%,
      rgba(255, 255, 255, 1) 51%,
      rgba(148, 187, 233, 1) 100%);
}

.main-box {
  margin: 0 auto;

  /* border: solid rgba(109, 109, 109, 0.329) 2px; */
  /* padding: 0; */
}

.my-swal-container {
  z-index: 5000 !important;
}

.custom-margin {
  border-left: 4.5em;
}

.swtitle,
.swtext {
  color: black;
}

.confirm-button {
  background-color: #4caf50 !important;
  /* Green background */
  color: white !important;
  /* White text */
  border-radius: 8px !important;
}

.cancel-button {
  background-color: #ec1d1d !important;
  /* Green background */
  color: white !important;
  /* White text */
  border-radius: 8px !important;
}

.qr-code-img {
  max-width: 100%;
  height: auto;
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
}

.M-aleart {
  top: 0px;
  right: 30px;
  z-index: 6000;

  text-align: start;
}

.swal2-icon.no-border-icon {
  border: none;
  box-shadow: none;
  font-size: 1.5em;
  margin-top: 0;
  margin-bottom: 0;
}
</style>
